import React, { useEffect, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useKeyboardControls } from "@react-three/drei"
import { vec3, quat, RigidBody } from '@react-three/rapier'
import * as THREE from 'three'

export default function Boat(props) {
  const boat = useGLTF("/models/boat.glb");
  const [ subscribeKeys, getKeys ] = useKeyboardControls()

  const body = useRef()

  var yaw = 0
  var roll = 0
  const maxRoll = 0.3; // Set your desired maximum roll value here

  // to-do: change impulse to acceleration
  useFrame((state, delta) => {
    /**
     * Controls
     */
    const { forward, backward, leftward, rightward } = getKeys()

    var impulse = 0

    // Adjust these values for tighter control
    const impulseStrength = 1200 * delta // Increase for more responsive acceleration
    const yawStrength = 2 * delta // Increase for quicker turning
    const rollStrength = 0.15 // Adjust roll strength as needed

    if (forward) {
        impulse += impulseStrength
    }
    if (backward) {
        impulse -= impulseStrength
    }
    // Steer left
    if (leftward) {
        yaw += yawStrength
        roll = -rollStrength
    }
    // Steer right
    else if (rightward) {
        yaw -= yawStrength
        roll = rollStrength
    }

    if (leftward || rightward) {
      roll += (leftward ? -1 : 1) * rollStrength * delta;
      roll = THREE.MathUtils.clamp(roll, -maxRoll, maxRoll); // Clamp the roll value
    } else {
        // Dampen roll over time
        roll *= 0.9;
    }
  // // Straighten out
  //   else {
  //       // if (Math.abs(yaw) >= yawStrength) {
  //       //     yaw -= yawStrength * Math.sign(yaw)
  //       // }
  //       // else {
  //       //     yaw = 0
  //       // }
  //       // Reduce roll when not turning
  //       roll *= 0.9; // Dampen roll over time
  //   }

    if (body.current) {
        // Get existing rotation as quaternion
        const currentRotation = quat(body.current.rotation());

        const targetRotation = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, yaw, roll, 'XYZ'));

        // Slerp for smooth rotation transition
        currentRotation.slerp(targetRotation, 0.1);

        // Set the new rotation and 
        // make sure there is no pitch or roll by resetting the x component
        body.current.setRotation(currentRotation);


        // Calculate the direction vector based on the yaw
        const direction = new THREE.Vector3(0, 0, 1).applyQuaternion(currentRotation);

        // Apply the impulse in the direction the boat is facing
        if (impulse !== 0) {
            body.current.applyImpulse(direction.multiplyScalar(impulse), true);
        }
    }
})

  return <>
  <RigidBody
    // type="kinematicPosition"
    canSleep={ false }
    colliders="hull"
    ref={body}
    linearDamping={4}
    {...props}
  >
    <primitive object={boat.scene} />
  </RigidBody>
  </>
}

useGLTF.preload("/models/boat.glb");
